import { queryClient } from '@/infra/http'
import { decodeImportImage } from '@/main/routes/helpers/loaders'
import { QueryClient } from 'react-query'

/**
 * Loads dependent registration data for company manager
 * Fetches holder account profile and registration options
 */
export async function loadCompanyManagerDependentRegistration(accountId: string) {
  const [holderAccountProfile, dependentRegistrationOptions, successImage] = await Promise.all([
    promiseAccountProfile(accountId, queryClient),
    promiseDependentRegistrationOptions(accountId, queryClient),
    decodeImportImage(import('@images/completed.svg'))
  ])

  return {
    holderAccountProfile,
    dependentRegistrationOptions,
    successImage
  }
}

async function promiseAccountProfile(accountId: string, queryClient: QueryClient) {
  const module = await import(
    '@remote/account/company-manager/remote-company-manager-account-profile-factory'
  )
  const makeRemote = module.makeRemoteCompanyManagerAccountProfile
  const remote = makeRemote(accountId, queryClient)
  return remote.profile()
}

async function promiseDependentRegistrationOptions(accountId: string, queryClient: QueryClient) {
  const module = await import(
    '@remote/account/company-manager/remote-company-manager-dependent-registration-options-factory'
  )
  const makeRemote = module.makeRemoteCompanyManagerDependentRegistrationOptions
  const remote = makeRemote(accountId, queryClient)
  return remote.loader()
}
